import { put, cancelled } from 'redux-saga/effects';
import { Creators as LoginActions } from '../ducks/login';

export function* postLoginRequest(payload) {
  try {
    const requestOptions = {
      method: 'GET',
      headers: {},
    };
    const res = yield fetch('', requestOptions)
      .then(response => response.json());
    yield put(LoginActions.getLoginSuccess(res));
    console.log('response' + JSON.stringify(res));
  } catch (err) {
    console.log(JSON.stringify(err));
    yield put(LoginActions.getLoginFailure());
  }
  finally {
    if (yield cancelled()) {
      yield put({ type: LoginActions.loginCancelled() })
    }
  }
}

export function* postLogoutRequest(payload) {
  yield put(LoginActions.getLoginSuccess([]));
}
